enum NifUnitTypeEnum {
	retailUnit = 'ru',
	store = 'sto'
}

export default NifUnitTypeEnum;
